import React, { useState } from "react";

function Image({
    src = "",
    height = "auto",
    width = "auto",
    alt = "Logo Eurus",
    className = "",
}) {
    const [loaded, toggleLoading] = useState(false);

    return (
        <img
            src={src}
            onLoad={() => toggleLoading(true)}
            className={`img-animated ${
                loaded ? "loaded" : "loading"
            } ${className}`}
            height={height}
            width={width}
            alt={alt}
        ></img>
    );
}

export default Image;
